import { useConexaQuery } from '@/hooks/useConexaQuery'
import { checkCnxTissTokenRequirement } from '../services'

export const useCheckCnxTissTokenRequirement = () => {
  return useConexaQuery({
    queryKey: ['check-clinic-token-requirement'],
    service: () => checkCnxTissTokenRequirement(),
    config: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  })
}
